import { useSelector } from 'react-redux';

import { RootState } from '@/utils/store';

const useTableColumnViewOption = (
  tableViewOptionsKey: string,
  columns: Array<{ title: string; defaultVisibility: boolean }>,
) => {
  const tableViewOptions = useSelector(
    (rootState: RootState) => rootState.options.tableViews[tableViewOptionsKey],
  );

  return (title: string) => {
    if ((tableViewOptions ?? {})[title] !== undefined) {
      return tableViewOptions[title];
    }
    return (
      columns.find((col) => col.title === title)?.defaultVisibility ?? false
    );
  };
};

export default useTableColumnViewOption;
